import { Hourglass, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { usePublicPageForceLightClass } from "@/hooks/use-public-page-theme";
import { GATE_COPY } from "@/lib/approval";

// Mostrata al posto della dashboard finché l'attività non è approvata (o è rifiutata/sospesa) —
// vedi ProtectedRoute.js. Non espone nulla dell'amministrazione: solo lo stato e il logout.
export default function ApprovalGate({ status }) {
  const { logout } = useAuth();
  const forceLightClass = usePublicPageForceLightClass();
  const copy = GATE_COPY[status] || GATE_COPY.pending_approval;
  return (
    <main className={`min-h-dvh startup-bg flex items-center justify-center px-5 py-10 ${forceLightClass}`} data-testid="approval-gate" data-status={status}>
      <Card className="w-full max-w-md rounded-[2rem] bg-white/82 backdrop-blur-2xl border border-white/80 shadow-2xl">
        <CardHeader>
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl startup-button text-white mb-4">
            <Hourglass className="h-6 w-6" />
          </div>
          <CardTitle className="font-display text-3xl tracking-[-0.05em]" data-testid="approval-gate-title">{copy.title}</CardTitle>
          {copy.lines.map((line) => (
            <p key={line} className="mt-3 text-sm leading-6 text-muted-foreground">{line}</p>
          ))}
        </CardHeader>
        <CardContent>
          <Button type="button" variant="outline" onClick={logout} className="w-full rounded-2xl h-12 font-extrabold bg-white/60" data-testid="approval-gate-logout">
            <LogOut className="mr-2 h-4 w-4" /> Esci
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
